// extracted by mini-css-extract-plugin
export var measureBox = "_cr-0";